// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"415":"d7b5f3ca","418":"b2675754","480":"05976f6d","606":"209138cd"}[chunkId] + ".js";
};